import React, { useState } from "react";
import { SearchFacet } from "~assets/frontend/frame/frm-search/components/SearchFacet";
import Translator from "bazinga-translator";
import { dispatchTrackingEvent } from "~assets/global/tracking/tracking-event";
export const SearchFacets = ({ facets }) => {
    const [selectedFacet, setSelectedFacet] = useState(null);
    const onSelectFacet = (facetName) => {
        const uiEvent = {
            name: "ui",
            payload: {
                ui_component: "frm-search",
                ui_function: "select",
                ui_action: "facet",
                ui_target: facetName ? facetName : "all",
            },
        };
        dispatchTrackingEvent(uiEvent);
        setSelectedFacet(facetName);
    };
    const facetsWithResults = facets.filter((facet) => facet.total > 0);
    const filteredFacets = facets.filter((facet) => (facet.facetName === selectedFacet || selectedFacet === null) && facet.items.length > 0);
    return (React.createElement("div", null,
        facetsWithResults.length > 1 && (React.createElement("div", { className: "-mx-24 mb-36 overflow-x-auto overflow-y-visible sm:mx-0 sm:overflow-visible" },
            React.createElement("ol", { className: "mx-24 inline-flex gap-x-24 sm:mx-0 sm:flex-wrap" },
                React.createElement("li", { className: `flex-shrink-0` },
                    React.createElement("button", { className: `py-12 transition-colors hocus:text-red-100 ${selectedFacet === null ? "text-red-100 underline underline-offset-[6px] xl:underline-offset-8" : ""}`, onClick: () => {
                            onSelectFacet(null);
                        } }, Translator.trans("frm-search.facets.all", {}, "frontend"))),
                facetsWithResults.map((facet) => {
                    return (React.createElement("li", { key: facet.facetName },
                        React.createElement("button", { className: `py-12 transition-colors hocus:text-red-100 ${selectedFacet === facet.facetName ? "text-red-100 underline underline-offset-[6px] xl:underline-offset-8" : ""}`, onClick: () => {
                                onSelectFacet(facet.facetName);
                            } }, Translator.trans("frm-search.facets." + facet.facetName, {}, "frontend"))));
                })))),
        React.createElement("div", { className: "flex flex-col gap-48" }, filteredFacets.map((facet) => {
            return React.createElement(SearchFacet, Object.assign({ key: facet.facetName }, facet));
        }))));
};
